import { displayMessage } from '../helpers/messages'

export const EAlertTypes = {
    SUCCESS: { param: 'success', defaultTitle: displayMessage('SUCCESS') },
    WARNING: { param: 'warning', defaultTitle: displayMessage('WARNING') },
    ERROR: { param: 'error', defaultTitle: displayMessage('ERROR') },
    INFO: { param: 'info', defaultTitle: displayMessage('WARNING') },
}
